import { Injectable } from '@angular/core';
import {
    MultiRegistrationConfig,
    MultiregistrationController,
    UIState,
} from '@azavista/participants/dist/event-app/multiregistration/multiregistration-controller';
import { ApiService } from '../api.service';
import { ShoppingCartResultUI } from '@azavista/payments/lib/shopping-cart';
import { AppLoggerService, LogLevel } from '../app-logger.service';
import { getIsRequireTicket } from './utils';

export type MultiRegistrationInitData = MultiRegistrationConfig & {
    cartResult: ShoppingCartResultUI;
};

@Injectable({
    providedIn: 'root',
})
export class MultiRegistrationService {
    controller?: MultiregistrationController | undefined;
    config?: MultiRegistrationConfig | undefined;
    uiState?: UIState | undefined;

    constructor(
        private apiSvc: ApiService,
        private logSvc: AppLoggerService,
    ) {}

    async init(
        event_id: string,
        config: MultiRegistrationConfig,
        cartDataFn: () => ShoppingCartResultUI,
        stateHandlerFn?: (state: UIState) => void
    ) {
        if (this.config?.workflow_id === config.workflow_id) {
            return;
        }
        this.controller = undefined;
        this.config = config;
        this.controller = new MultiregistrationController(event_id, config);
        const registrationData = await this.apiSvc.getMultiRegistration(
            this.config.workflow_id
        );
        this.controller.initialize(registrationData, getIsRequireTicket(config) ? cartDataFn() : null);
        this.logSvc.log(LogLevel.log, 'Multi Registration Init', {
            controller: this.controller,
            registrationData, config,
        });
        this.subscribeToUiState(stateHandlerFn || (() => {}));
    }

    destroy() {
        this.config = undefined;
        this.controller = undefined;
        this.uiState = undefined;
        this.logSvc.log(LogLevel.log, 'Multi Registration Destroyed');
    }

    subscribeToUiState(stateHandlerFn: (state: UIState) => void) {
        const subscription = this.controller?.getUIState();
        subscription.subscribe(() => {
            const state: UIState = {...subscription.getState()};
            this.uiState = state;
            this.logSvc.groupCollapsed('Multi Registration State');
            this.logSvc.log(LogLevel.log, { state, controller: this.controller });
            this.logSvc.groupEnd();
            stateHandlerFn(state);
        });
    }

    async submitMultiRegistration() {
        if (this.controller && !this.hasError()) {
            try {
                const payload = this.controller.getSubmissionPayload();
                await this.apiSvc.updateMultiRegistration(
                    this.config.workflow_id,
                    payload
                );
                return true;
            } catch {
                return false;
            }
        }
        return false;
    }

    hasError() {
        return this.controller?.hasGlobalErrors() || this.controller?.hasParticipantErrors();
    }
}
